import { proposalsPath, accountPath, buildingPath, inspectionPath } from 'routes';

export default ({ screen, screenId }) => {
  switch (screen) {
    case 'account':
      return accountPath({ id: screenId, anchor: 'proposals', _options: true });
    case 'building':
      return buildingPath({ id: screenId, anchor: 'proposals', _options: true });
    case 'inspection':
      return inspectionPath(screenId);
    default:
      return proposalsPath();
  }
};
